import { render, staticRenderFns } from "./PainelPDIPPI2025dev.vue?vue&type=template&id=1c23ce4b&"
import script from "./PainelPDIPPI2025dev.vue?vue&type=script&lang=js&"
export * from "./PainelPDIPPI2025dev.vue?vue&type=script&lang=js&"
import style0 from "./PainelPDIPPI2025dev.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VOverlay,VProgressCircular,VRow})
